import React, { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import routes from '@/router/routes';
import Loading from '@/components/Loading';
import './index.less';
import appModel from '@/models/appModel';

appModel.init();

const App = () => {
  const location = useLocation();

  useEffect(() => {
    const { pathname } = location;
    const { title = '' } =
      routes.find((route) => route.path === pathname) || {};
    document.title = title;
  }, [location]);

  return (
    <div className="root-page-view">
      <Suspense fallback={<Loading />}>
        <div id="detail">
          <Outlet />
        </div>
      </Suspense>
    </div>
  );
};

export default App;
